import * as eobigApi from "../endpoints/eobig";

/**
 * Сервісні обгортки eObig — повертають response.data і централізовано логують помилки.
 */

export async function try_SendInvoice(documentId, payload) {
  try {
    const response = await eobigApi.sendInvoice(documentId, payload);
    return response.data;
  } catch (error) {
    console.error("[Service Error][eobig.sendInvoice]:", error);
    throw error;
  }
}

export async function try_SendWaybill(documentId, payload) {
  try {
    const response = await eobigApi.sendWaybill(documentId, payload);
    return response.data;
  } catch (error) {
    console.error("[Service Error][eobig.sendWaybill]:", error);
    throw error;
  }
}

export async function try_SignAndSend(documentId, payload) {
  try {
    const response = await eobigApi.signAndSend(documentId, payload);
    return response.data;
  } catch (error) {
    console.error("[Service Error][eobig.signAndSend]:", error);
    throw error;
  }
}

export async function try_SubscribeWebhook(providerId) {
  try {
    const response = await eobigApi.subscribeWebhook(providerId);
    return response.data;
  } catch (error) {
    console.error("[Service Error][eobig.subscribeWebhook]:", error);
    throw error;
  }
}

export async function try_GetDocStatus(providerId, docId) {
  try {
    const response = await eobigApi.getDocStatus(providerId, docId);
    return response.data;
  } catch (error) {
    console.error("[Service Error][eobig.getDocStatus]:", error);
    throw error;
  }
}
